module.exports = __webpack_public_path__ + "static/media/silver-car.23cd7da5.png";